import React from 'react';
import { LoaderSvg } from '../../styles/icons/LoaderSvg';

export const Loader = (): React.ReactElement => {
  return (
    <div className="w-full h-full flex justify-center items-center">
      <div style={{ width: '200px', height: '200px' }}>
        <LoaderSvg fill="#0a0a0a" />
      </div>
    </div>
  )
}